/*eslint-disable*/
import React, { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { MdPhotoLibrary } from 'react-icons/md';
import AccountInfoLayout from '../../Component/AccountInfoLayout';
import Footer from '../../Component/Footer';
import Header from '../../Component/Header';
import Tabs from '../../Component/Tabs';
import classes from './SavedSearches.module.css';
// import DropDown from '../../Component/DropDown/DropDown';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { AiOutlineSearch } from 'react-icons/ai';
import { BiBell } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Loader } from '../../Component/Loader';
import NoData from '../../Component/NoData/NoData';
import { PaginationComponent } from '../../Component/Pagination/Pagination';
import { recordsLimit } from '../../config/apiUrl';
import { useGetAllSavedSearchesQuery, usePostApiMutation } from '../../store/apiSlice/apiSlice';
import { commercialLangObj, residentialLangObj } from '../../config/DummyData';
import { useSelector } from 'react-redux';
import { m2ToFt2 } from '../../utils/helpers';

const SavedSearches = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('savedSearches');
  const { areaUnit } = useSelector((state) => state.converterReducer);
  const tabsData = [
    {
      icon: <MdPhotoLibrary />,
      text: `${t('savedProperties')} `,
      id: '1',
      key: 'property',
      countKey: 'propertyCount',
      buyRoute: '/buy',
      rentRoute: '/rent'
    },
    {
      icon: <MdPhotoLibrary />,
      text: `${t('savedProjects')}`,
      id: '2',
      key: 'project',
      countKey: 'projectCount',
      route: '/projects'
    },
    {
      icon: <MdPhotoLibrary />,
      text: `${t('savedEvents')}`,
      id: '3',
      key: 'event',
      countKey: 'eventCount',
      route: '/events'
    }
  ];
  const [tabValue, setTabValue] = useState(tabsData[0]);
  const [page, setPage] = useState(1);

  const { isLoading, data, refetch, isFetching } = useGetAllSavedSearchesQuery({
    page: page,
    limit: recordsLimit,
    type: tabValue?.key
  });
  const [deleteApiFunc, { isLoading: isDeleting }] = usePostApiMutation();
  const [checkboxArray, setCheckboxArray] = useState([]);

  const deleteApi = async (deleteAll) => {
    if (!deleteAll && checkboxArray?.length == 0) {
      return toast.error(t('toast.error'));
    }
    if (deleteAll && data?.data?.length == 0) {
      return;
    }

    const deleteResponse = await deleteApiFunc({
      url: `savedSearch/delete`,
      data: {
        ...(deleteAll
          ? { isDeleteAll: deleteAll, type: tabValue?.key }
          : {
              ids: checkboxArray?.map((e) => e?._id)
            })
      },

      method: 'DELETE',
      tag: `savedSearches`
    });
    if (deleteResponse?.data) {
      setCheckboxArray([]);
      toast.success(
        `${deleteAll ? 'All' : ''} ${t('toast.savedSearch')}${
          checkboxArray?.length != 0 || deleteAll ? 'es' : ''
        } ${t('toast.deletedSuccessfully')}`
      );
      // refetch();
      navigate(0);
    }
  };

  return (
    <>
      <div className={`page_bg ${classes.page}`}>
        <Header containerClass="customContainer" />
        <AccountInfoLayout>
          <Tabs
            className={classes.tab_main}
            tabClass={classes.tab_class_main}
            value={tabValue}
            tabsData={tabsData?.map((a) => ({
              ...a,
              text: `${a?.text} (${data?.[a?.countKey] ?? 0})`
            }))}
            setValue={(e) => {
              setTabValue(e);
            }}
          />
          <div className={classes.delete_div}>
            <div
              style={{
                display: 'flex'
              }}>
              <p>{`${t('showing')} ${data?.data?.length ?? 0} - ${
                data?.[tabValue?.countKey] ?? 0
              } ${t('savedSearches')}`}</p>
              <p
                onClick={() => {
                  setCheckboxArray([]);
                  deleteApi(true);
                }}
                className={isDeleting ? 'c-d' : 'c-p'}>
                {t('deleteAll')}
              </p>
              <p onClick={() => deleteApi(false)} className={isDeleting ? 'c-d' : 'c-p'}>
                {t('deleteSelected')}
              </p>
            </div>
          </div>

          <Row>
            <Col md={12}>
              {isLoading || isFetching ? (
                <Loader />
              ) : data?.data?.length === 0 ? (
                <NoData text={t('noData')} />
              ) : (
                data?.data?.map((item, index) => {
                  // const title = discardUndefinedOrNullValues({
                  //   province: item?.province?.name?.en,
                  //   [item?.type]: item?.entity?.title?.en,
                  //   town: item?.town?.name?.en,
                  //   neighborhood: item?.neighborhood?.name?.en,
                  //   address: item?.address,
                  //   maxPrice: item?.data?.maxPrice,
                  //   minPrice: item?.data?.minPrice,
                  //   noOfRooms: item?.data?.noOfRooms?.en,
                  //   noOfBathrooms: item?.data?.noOfBathrooms,
                  //   propertyPurpose: item?.data?.propertyPurpose?.en,
                  //   parkingSpace: item?.data?.parkingSpace,
                  //   floorLevel: item?.data?.floorLevel?.en,
                  //   furniture: item?.data?.furniture?.en,
                  //   ...(item?.exteriorAmenities?.length > 0 && {
                  //     exteriorAmenities: item?.exteriorAmenities
                  //       ?.map((a) => a?.title?.en)
                  //       .join(', ')
                  //   }),
                  //   ...(item?.interiorAmenities?.length > 0 && {
                  //     interiorAmenities: item?.interiorAmenities
                  //       ?.map((a) => a?.title?.en)
                  //       .join(', ')
                  //   })
                  // });
                  return (
                    <div key={index} className={classes.search_div}>
                      <div className={classes.bell_div}>
                        <BiBell color={'var(--secondary-clr)'} size={45} />
                        <div className={classes.left_div}>
                          <h6 className="textOneLine">
                            {item?.title}
                            {/* {Object.entries(title)
                              ?.slice(0, 4)
                              ?.map(
                                (a) =>
                                  `${capitalizeFirstLetter(
                                    a[0]?.replace(formRegEx, formRegExReplacer)
                                  )}: ${a[1]}`
                              )
                              ?.join(', ')} */}
                          </h6>
                          <p>{moment(item?.createdAt).format('DD-MMM-YYYY')}</p>
                        </div>
                      </div>
                      <div className={classes.right_div}>
                        <div
                          className={classes.icon_div}
                          onClick={() => {
                            navigate(
                              tabValue?.route
                                ? tabValue?.route
                                : item?.data?.propertyPurpose == 'buy'
                                ? tabValue?.buyRoute
                                : tabValue?.rentRoute,
                              {
                                state: {
                                  ...item?.data,
                                  ...(item?.data?.minArea
                                    ? {
                                        minArea:
                                          areaUnit == 'm²'
                                            ? item?.data?.minArea
                                            : parseInt(
                                                m2ToFt2({
                                                  area: item?.data?.minArea,
                                                  areaUnit: 'ft²',
                                                  unit: false
                                                })
                                              )
                                      }
                                    : {}),
                                  ...(item?.data?.maxArea
                                    ? {
                                        maxArea:
                                          areaUnit == 'm²'
                                            ? item?.data?.maxArea
                                            : parseInt(
                                                m2ToFt2({
                                                  area: item?.data?.maxArea,
                                                  areaUnit: 'ft²',
                                                  unit: false
                                                })
                                              )
                                      }
                                    : {}),
                                  province: item?.province || null,
                                  neighborhood: item?.neighborhood || null,
                                  town: item?.town || null,
                                  entity: item?.entity || null,
                                  ...(item?.propertyClassification
                                    ? {
                                        propertyClassification:
                                          item?.propertyClassification == 'residential'
                                            ? residentialLangObj
                                            : commercialLangObj
                                      }
                                    : {}),
                                  ...(item?.interiorAmenities
                                    ? {
                                        interiorAmenities: item?.interiorAmenities
                                      }
                                    : {}),
                                  ...(item?.exteriorAmenities
                                    ? {
                                        exteriorAmenities: item?.exteriorAmenities
                                      }
                                    : {}),
                                  ...(item?.projectStatus
                                    ? {
                                        projectStatus: item?.projectStatus
                                      }
                                    : {}),
                                  ...(item?.unitType
                                    ? {
                                        unitType: item?.unitType
                                      }
                                    : {})
                                }
                              }
                            );
                          }}>
                          <AiOutlineSearch color="#fff" className="c-p" />
                        </div>
                        {/* <div className={classes.icon_div1}>
                          <RiDeleteBin5Line size={40} />
                        </div> */}
                        <Form.Check
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-end'
                          }}
                          className={isDeleting ? 'c-d' : 'c-p'}
                          name="group1"
                          type={'checkbox'}
                          id={`inline-checkbox-1`}
                          onChange={() => {
                            const newData = [...checkboxArray];
                            const index = newData.findIndex((e) => e?._id == item?._id);
                            if (index != -1) {
                              newData?.splice(index, 1);
                            } else {
                              newData.push(item);
                            }
                            setCheckboxArray(newData);
                          }}
                          checked={!!checkboxArray?.find((e) => e?._id == item?._id)}
                          disabled={isDeleting}
                        />
                      </div>
                    </div>
                  );
                })
              )}
            </Col>
            {!!data?.data?.length && !isLoading && (
              <Col md={12}>
                <PaginationComponent
                  currentPage={page}
                  setCurrentPage={setPage}
                  totalPages={Math.ceil(data?.totalRecords / recordsLimit)}
                />
              </Col>
            )}
          </Row>
        </AccountInfoLayout>
      </div>
      <Footer />
    </>
  );
};

export default SavedSearches;
